import React, { useState, useEffect } from 'react';
import EditableSection from './EditableSection';
import RichTextEditor from './RichTextEditor';

const SummaryEditor = ({ data, onSave, onRemove }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState(data || '');

  useEffect(() => {
    if (data !== undefined) setEditData(data);
  }, [data]);

  const handleSave = () => {
    onSave(editData);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditData(data || '');
    setIsEditing(false);
  };

  return (
    <EditableSection 
      title="Summary"
      isEditing={isEditing} 
      onEdit={() => setIsEditing(true)} 
      onCancel={handleCancel} 
      onSave={handleSave}
      onRemove={onRemove}
    >
      {isEditing ? (
        <div className="bg-gray-50 p-4 rounded-md border border-gray-200">
          <label className="block text-sm font-medium text-gray-700 mb-2 font-sans">Professional Summary</label>
          <RichTextEditor 
            value={editData} 
            onChange={setEditData} 
            placeholder="Write your professional summary here..."
          />
        </div>
      ) : (
        <div 
          className="resume-content text-[15px] leading-relaxed text-gray-900"
          dangerouslySetInnerHTML={{ __html: data || '<p class="text-gray-400 italic">No summary provided.</p>' }}
        />
      )}
    </EditableSection>
  );
};

export default SummaryEditor;
